<template>
  <div class="about">
    <img ref="mapImage" usemap="#workmap" src="../assets/MBH4_Main.jpg" class="map-image" />
    
    <map name="workmap" id="clickableimagearea">
      <area
        v-for="(area, index) in data"
        :key="index"
        target=""
        :alt="area.alt"
        :title="area.title"
        :data-maphilight="area.dataMapHighlight"
        :coords="area.coords"
        shape="poly"
        @click="goToLamela(area.image, area.getfromdb)"
      />
    </map>
  </div>
</template>

<script>
import $ from "jquery";
import { db, getDocs, collection } from "@/firebase";
import imageMapResize from "image-map-resizer";
import "maphilight";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import 'tippy.js/themes/light.css';
import { useRouter } from 'vue-router';
const router = useRouter();
export default {
  data() {
    return {
      data: [],
      imageSelector: ".map-image",
      resizeTimeout: null,
    };
  },
  mounted() {
    this.loadData();
    window.addEventListener("resize", this.debouncedResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedResize);
  },
  methods: {
    initImageMap() {
      this.$nextTick(() => {
        imageMapResize(); // Prilagođava veličinu slike i mape
        $(this.imageSelector).maphilight(); // Aktivira boje na mapiranim područjima
      });
    },
    goToLamela(image, getfromdb){
        console.log(image);
        localStorage.setItem("nextImage", image);
        localStorage.setItem("getFromDB", getfromdb);
        this.$router.push('/lamela');
      },
    loadData() {
      getDocs(collection(db, "mbh4_lamele")).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const docData = doc.data();
          if (docData.areas) {
            this.data.push(...docData.areas);
          }
        });
        console.log("Učitani podaci:", this.data);

        this.$nextTick(() => {
          setTimeout(() => {
            imageMapResize();
            $(this.imageSelector).maphilight();
            this.initTooltips();
          }, 100);
        });
      });
    },
    debouncedResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.initImageMap();
      }, 300);
    },
    initTooltips() {
      this.$nextTick(() => {
        document.querySelectorAll("area").forEach((area) => {
          const info = JSON.parse(area.getAttribute("data-info") || "{}");
          if (info.id) {
            tippy(area, {
              content: `
                <div style="text-align:center;">
                  <img src="${info.image}" class="tooltip-image" style="width: 250px; height: 150px; object-fit: cover;" />
                      <p style="font-family: Arial, Helvetica, sans-serif !important;"></p><strong>Banesa:</strong> ${info.id}</p>
                     <p style="font-family: Arial, Helvetica, sans-serif !important;"></p>strong>Siperfaqja:</strong> ${info.size}</p>
                     <p style="font-family: Arial, Helvetica, sans-serif !important;"></p><strong>Tipi:</strong> ${info.type}</p>
                </div>`,
              allowHTML: true,
              interactive: true,
              animation: "fade",
              followCursor: true,
              placement: "top",
              offset: [-180, 10],
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.about {
  max-width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.map-image {
  width: 100%;
  height: auto;
  display: block;
  max-width: 100%;
}

</style>
